import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);


  const breadcrumbs = [
    { name: "Home", path: "/" },
    ...pathnames.map((value, index) => {
      const to = "/" + pathnames.slice(0, index + 1).join("/");
      const name = value.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
      return { name, path: to };
    }),
  ];

  return (
  <>
  {location.pathname !== "/" && (
    <nav className="text-sm p-4 mx-auto max-w-7xl text-gray-600">
      {breadcrumbs.map((crumb, index) => (
        <span key={crumb.path}>
          <Link
            to={crumb.path}
            className={`hover:underline ${
              index === 0 ? "font-semibold text-gray-900" : ""
            }`}
          >
            {crumb.name}
          </Link>
          {index < breadcrumbs.length - 1 && (
            <span className="mx-1">/</span>
          )}
        </span>
      ))}
    </nav>
  )}
</>

  );
};

export default Breadcrumbs;
